import { StdResponse, request } from "@/global/config/request";


export function getGlobalDevices(params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-devices`, {
        params: {
            ...params,
        }
    })
}